<template>
  <div class="layout-dashboard">
    <div class="dashboard-nav">
      <div class="nav-container">
        <div class="user-info">
          <div
            class="avatar-wrap"
            :style="{ transform: `scale(${userInfo.userLevel > 5 ? 0.8 : 1})` }"
            @click="openWebview(`/player-detail?uuid=${userInfo.uuid}`)"
          >
            <fps-avatar :src="userInfo.avatarUrl" :level="userInfo.userLevel" />
          </div>
          <div class="nickname">
            <span>{{ userInfo.nickname }}</span>
            <div
              class="userlevel-tag level-mg"
              :class="`level-${userInfo.userLevel}`"
            ></div>
          </div>
        </div>
        <div class="user-positive">
          <div class="title">
            <p @click="introPositive = true">{{$t('upgrade_page_layout_header_19')}}</p>
          </div>
          <fps-switch
            class="switch"
            :value="isOnline"
            :loading="statusLoading"
            @change="changeStatus"
          />
        </div>
        <div class="data-info">
          <div @click="showFollowing = true">
            <p>{{ followingNumber }}</p>
            <span>{{$t('upgrade_page_views_player_detail_index_1111')}}</span>
          </div>
          <div @click="showFollower = true">
            <p>
              {{ userInfo.follower }}
              <span v-if="redCircleInfo.followers" class="rebbot" />
            </p>
            <span>{{$t('upgrade_page_views_master_index_209')}}</span>
          </div>
          <div @click="showVisitor = true">
            <p>
              {{ userInfo.recentVisitedUser || 0 }}
              <span v-if="redCircleInfo.visitedTimes" class="rebbot" />
            </p>
            <span>{{$t('upgrade_page_views_player_detail_index_1112')}}</span>
          </div>
        </div>
        <div class="nav-list">
          <router-link
            class="nav-item"
            v-for="nav in allNavList"
            :key="nav.path"
            :to="nav.path"
            @click.native="signRed(nav)"
          >
            <div class="nav-name">
              {{ nav.name }}
              <span class="rebbot" v-if="nav.rebbot"></span>
            </div>
          </router-link>
        </div>
      </div>
      <LayoutFooter :isNav="true" :darkMode="true" />
    </div>
    <div id="scroll-wrap" class="dashboard-container">
      <div class="dashboard-wrap">
        <router-view></router-view>
      </div>
    </div>
    <DialogPositive v-model="introPositive" />
    <DialogVisitor v-model="showVisitor" />
    <DialogFollower v-model="showFollower" />
    <DialogFollowing v-model="showFollowing" />
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';
import LayoutFooter from '@/upgrade-page/layout/footer';
import DialogPositive from '@/upgrade-page/layout/dialog-positive';
import DialogFollower from '@/upgrade-page/views/player-detail/dialog-follower';
import DialogFollowing from '@/upgrade-page/views/player-detail/dialog-following';
import DialogVisitor from '@/upgrade-page/views/player-detail/dialog-visitor';

export default {
  components: {
    LayoutFooter,
    DialogPositive,
    DialogFollower,
    DialogFollowing,
    DialogVisitor
  },
  data() {
    return {
      baseNavList: [
        {
          name: i18n.t('upgrade_page_views_dashboard_layout_1480'),
          path: '/player/dashboard',
          rebbot: false
        },
        {
          name: i18n.t('components_order_order_list_489'),
          path: '/player/orders',
          rebbot: false
        },
        {
          name: i18n.t('upgrade_page_views_wallet_index_697'),
          path: '/player/income',
          rebbot: false
        },
        {
          name: i18n.t('upgrade_page_views_dashboard_layout_1481'),
          path: '/player/skills',
          rebbot: false
        },
        {
          name: i18n.t('upgrade_page_views_dashboard_layout_1482'),
          path: '/player/recommend',
          rebbot: false
        }
      ],
      statusLoading: false, // 切換積極接單
      introPositive: false,
      showVisitor: false,
      showFollower: false,
      showFollowing: false,
      hasOpenInvite: !!localStorage.getItem('hasOpenInvite')
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'redCircleInfo']),
    // 積極接單
    isOnline() {
      return this.userInfo && this.userInfo.wantOrder;
    },
    // 追蹤中數量
    followingNumber() {
      const result = this.userInfo ? this.userInfo.following : 0;
      return result < 0 ? 0 : result;
    },
    allNavList() {
      if (this.userInfo.signUpTag)
        return this.baseNavList.concat([
          {
            name: i18n.t('upgrade_page_views_dashboard_layout_1483'),
            path: '/player/invite-record',
            rebbot: !this.hasOpenInvite
          }
        ]);
      return this.baseNavList;
    }
  },
  methods: {
    // 切换積極接單状态
    changeStatus() {
      if (this.statusLoading) return;
      this.statusLoading = true;
      this.$http
        .post('/user/save/onlineStatus', {
          userOnlineStatus: this.isOnline ? 'Offline' : 'Online'
        })
        .then(async () => {
          await this.$store.dispatch('app/getUserInfo');
          this.statusLoading = false;
        });
    },
    /**
     * @description: 簽約用戶消除邀請頁小紅點
     * @param {*}
     * @return {*}
     */
    signRed(nav) {
      if (nav.path === '/player/invite-record') {
        this.hasOpenInvite = true;
        localStorage.setItem('hasOpenInvite', 1);
      }
    }
  },
  created() {    
    if(this.$route.query) {
     this.showVisitor = this.$route.query.visitor || false
    }
  }
};
</script>

<style lang="scss">
.layout-dashboard {
  width: 100% !important;
  height: 100% !important;
  @include flex(center, stretch);
  .dashboard-nav {
    flex-shrink: 0;
    width: 240px;
    height: 100%;
    overflow-y: auto;
    background-color: #353c4a;
    @include hideScrollBar(0, 0);
    .nav-container {
      min-height: calc(100% - 91px);
    }
  }
  .dashboard-container {
    flex-grow: 1;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .dashboard-wrap {
    flex: 1;
    > * {
      position: relative;
      width: 100%;
      max-width: 980px;
      margin: 0 auto;
    }
  }
}
</style>

<style lang="scss" scoped>
.user-info {
  @include flex(flex-start, center, column);
  padding: 32px 20px 0;
  overflow: hidden;
  .avatar-wrap {
    width: 64px;
    height: 64px;
    cursor: pointer;
  }
  .nickname {
    @include flex;
    height: 26px;
    width: 100%;
    overflow: hidden;
    margin-top: 8px;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    span {
      @include ellipsis;
    }
    .userlevel-tag {
      height: 18px;
      margin-left: 8px;
    }
  }
}
.user-positive {
  @include flex;
  padding: 12px 0;
  .title {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    margin-right: 8px;
    cursor: pointer;
    &:hover {
      color: #fff;
    }
  }
  .switch {
    width: 44px;
    height: 26px;
  }
}
.data-info {
  @include flex(space-between);
  padding: 35px 20px;
  text-align: center;
  & > div {
    cursor: pointer;
    @include flex();
    flex-direction: column;
  }
  p {
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    position: relative;
  }
  span {
    display: block;
    margin-top: 2px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    line-height: 16px;
  }
}
.nav-list {
  flex-grow: 1;
  padding-top: 24px;
  border-top: 1px solid rgba($color: #f1f4f6, $alpha: 0.1);
  .nav-item {
    @include flex(flex-start);
    height: 56px;
    padding: 0 24px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    line-height: 20px;
    &:hover {
      background: rgba($color: #4f5767, $alpha: 0.4);
    }
    &.router-link-active {
      font-weight: 500;
      background: rgba($color: #4f5767, $alpha: 0.7);
      color: #fff;
    }
  }
}
.nav-name {
  position: relative;
}
.rebbot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  left: 100%;
  top: -2px;
  background: #f57976;
}
</style>
